<template>
  <v-flex
    shrink
    class="text-xs-center"
    mx-2
    pa-1
  >
    <p class="mb-1">
      {{ person.relationName }}
    </p>
    <p class="mb-0 fw-600 f-1">
      {{ person.newName }}
    </p>
    <p>{{ person.age }} {{ ageOpt }}</p>
  </v-flex>
</template>

<script>
export default {
    name: 'FamilyMember',
    props: {
        person: {
            required: true,
            type: Object
        }
    },
    computed: {
        ageOpt () {
            return this.person.ageOption === 1
                ? this.$t('preview.family_description.age.1')
                : this.$t('preview.family_description.age.2');
        }
    }
};
</script>

<style scoped></style>
